import { wrap } from "lodash";
import { tracker } from "./tracker/Tracker";
import { DateTime } from "luxon";
export const wrapLogger = (level) => wrap(console[level], (func, ...data) => {
    tracker.captureLog(level, ...data);
    const timestamp = DateTime.now().toUTC().toFormat("HH:mm:ss:SSS");
    if (level === "error") {
        console.log(timestamp);
        return func("[GVC]", ...data);
    }
    else {
        return func(timestamp, ...data);
    }
});
export const Logger = {
    ...console,
    debug: wrapLogger("debug"),
    log: wrapLogger("log"),
    warn: wrapLogger("warn"),
    info: wrapLogger("info"),
    error: wrapLogger("error"),
};
//# sourceMappingURL=Logger.js.map